import { render, staticRenderFns } from "./userOverviewTitleTab.vue?vue&type=template&id=34e99f3e"
import script from "./userOverviewTitleTab.vue?vue&type=script&lang=js"
export * from "./userOverviewTitleTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports